// Court Matiks — Root component. Routes are intentionally flat for the MVP.
import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import { pageview } from "@/lib/analytics";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Tournaments from "@/pages/Tournaments";
import SubmitTournament from "@/pages/SubmitTournament";
import AdminDashboard from "@/pages/AdminDashboard";
import Profile from "@/pages/Profile";
import Sandbox from "@/pages/Sandbox";
import PlayersDirectory from "./pages/PlayersDirectory";
import PlayerCardView from "./pages/PlayerCardView";
import TournamentDetail from "./pages/TournamentDetail";
import TournamentGames from "./pages/TournamentGames";
import TournamentGameModeSelect from "./pages/TournamentGameModeSelect";
import TournamentGameRecord from "./pages/TournamentGameRecord";
import LiveGameTracking from "./pages/LiveGameTracking";
import TwoScorerComingSoon from "./pages/TwoScorerComingSoon";

function GoogleAnalyticsRouteListener() {
  const location = useLocation();

  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Toaster position="top-right" theme="dark" />
        <BrowserRouter>
          <GoogleAnalyticsRouteListener />
          <Routes>
            {/* The Sandbox is intentionally fullscreen (no Layout chrome). */}
            <Route path="/sandbox/score" element={<Sandbox />} />

            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/tournaments" element={<Tournaments />} />
              <Route path="/tournaments/new" element={<SubmitTournament />} />
              <Route path="/tournaments/:tournamentId" element={<TournamentDetail />} />
              <Route path="/tournaments/:tournamentId/games" element={<TournamentGames />} />
              <Route path="/tournaments/:tournamentId/games/mode" element={<TournamentGameModeSelect />} />
              <Route path="/tournaments/:tournamentId/games/:gameId/mode" element={<TournamentGameModeSelect />} />
              <Route path="/tournaments/:tournamentId/games/:gameId" element={<TournamentGameRecord />} />
              <Route path="/tournaments/:tournamentId/games/live/:gameId" element={<LiveGameTracking />} />
              <Route path="/tournaments/:tournamentId/games/two-scorer" element={<TwoScorerComingSoon />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/me" element={<Profile />} />
              <Route path="/players/search" element={<PlayersDirectory />} />
              <Route path="/players/:playerId/portfolio" element={<PlayerCardView />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}
